import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=cb92dce8&scoped=true"
import script from "./error404.vue?vue&type=script&lang=js"
export * from "./error404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb92dce8",
  null
  
)

export default component.exports